/**
 * Converts an array of objects into an object; used for allowing O(1) access to keys
 * @param {array} array
 * @param {string} key
 * @returns {object}
 */
// eslint-disable-next-line no-return-assign
const convertImageArrayToObject = ({ array, key, target = false }) =>
	array.reduce((obj, item) => ((obj[item[key]] = target ? item.images : item), obj), {});

const capitalize = ([first, ...rest]) => first.toUpperCase() + rest.join('').toLowerCase();

const getRandomArrayItem = array => array[Math.floor(Math.random() * array.length)];

const replaceLetter = ({ word, letter, replace }) => word.replace(letter, replace);

function elementInViewport(element) {
	const bounding = element.getBoundingClientRect();
	const elementHeight = element.offsetHeight;
	const elementWidth = element.offsetWidth;

	if (
		bounding.top >= -elementHeight &&
		bounding.left >= -elementWidth &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight
	)
		return true;

	return false;
}

export { capitalize, convertImageArrayToObject, elementInViewport, getRandomArrayItem, replaceLetter };
